import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import type { SearchResponse } from '@/types/api'

const EMPTY: SearchResponse = { query: '', total: 0, groups: [] }

export function searchQueryKey(q: string) {
  return ['search', q] as const
}

/**
 * Server-side global search. Only fires once there are at least two characters
 * to search on (a single letter matches almost everything and is rarely what
 * the user means). Below that it resolves to an empty result set without a
 * network call. Debouncing lives in the caller.
 */
export function useSearch(query: string) {
  const q = query.trim()
  const enabled = q.length >= 2
  return useQuery({
    queryKey: searchQueryKey(q),
    enabled,
    placeholderData: (prev) => prev,
    staleTime: 30_000,
    queryFn: async () => {
      if (!enabled) return EMPTY
      return api.get<SearchResponse>(`/search?q=${encodeURIComponent(q)}`)
    },
  })
}
